import { ReactNode, CSSProperties } from "react";
import { HamburgerMenu } from "./hamburgerMenu";

interface HeaderShellProps {
    logoSrc: string;
    children?: ReactNode;
    onBurgerClick: () => void;
    showBurger: boolean;
    headerIconStyle?: CSSProperties;
    headerIconClassName?: string;
}

export const HeaderShell = (props: HeaderShellProps) => {
    return (
        <div
            id="header"
            //className="row w-100 align-items-stretch"
        >
            <HamburgerMenu onClick={props.onBurgerClick} visible={props.showBurger} />
            <div
                className={`header-image-container ${props.headerIconClassName || ""}`}
                style={props.headerIconStyle}
            >
                <img src={props.logoSrc} alt="Logo" className="header-image" />
                
            </div>

            {/* Text & Buttons Column */}
            <div className="header-text-container">
                {props.children}
            </div>
        </div>
    );
};
